import React, { useState } from "react";
import { ChevronDown, Activity } from "lucide-react";
import { fmtPct } from "@/lib/format";

const RowStat = ({ label, value, sub }) => (
  <div className="flex items-baseline justify-between py-2 border-b border-[#E5E2DC] last:border-0">
    <div>
      <div className="text-sm text-[#1C2B23]">{label}</div>
      {sub && <div className="text-[11px] text-[#5C6B62]">{sub}</div>}
    </div>
    <div className="font-mono-num text-sm text-[#1C2B23]">{value}</div>
  </div>
);

export default function AssetClassDrilldown({ assumptions }) {
  const [open, setOpen] = useState(false);
  if (!assumptions?.asset_class_assumptions) return null;
  const a = assumptions.asset_class_assumptions;

  const classes = [
    { key: "stocks", label: "Stocks", color: "#2B5339" },
    { key: "bonds", label: "Bonds", color: "#728A7C" },
    { key: "cash", label: "Cash", color: "#D4B886" },
  ];

  return (
    <div data-testid="asset-drilldown" className="bg-white border border-[#E5E2DC] rounded-2xl">
      <button
        data-testid="asset-drilldown-toggle"
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-6 py-5"
      >
        <div className="text-left">
          <div className="text-[11px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold inline-flex items-center gap-2">
            <Activity size={12} /> assumptions
          </div>
          <div className="font-display text-lg text-[#1C2B23] mt-1">
            Asset class drilldown — live vs historical
          </div>
        </div>
        <ChevronDown
          className={`transition-transform text-[#5C6B62] ${open ? "rotate-180" : ""}`}
          size={18}
        />
      </button>
      {open && (
        <div className="border-t border-[#E5E2DC] grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-[#E5E2DC]">
          {classes.map((c) => {
            const row = a[c.key];
            const liveMean = row?.live_mean;
            const liveVol = row?.live_vol;
            return (
              <div key={c.key} className="p-5" data-testid={`drill-${c.key}`}>
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-2.5 h-2.5 rounded-full" style={{ background: c.color }} />
                  <div className="font-display text-base text-[#1C2B23]">{c.label}</div>
                </div>
                <RowStat label="Blended mean (μ)" value={fmtPct((row?.mean ?? 0) * 100)} sub="annualized, nominal" />
                <RowStat label="Blended vol (σ)" value={fmtPct((row?.vol ?? 0) * 100)} sub="annualized stdev" />
                {liveMean !== undefined && (
                  <RowStat label="Live trailing-yr μ" value={fmtPct(liveMean * 100)} sub="from yfinance" />
                )}
                {liveVol !== undefined && (
                  <RowStat label="Live trailing-yr σ" value={fmtPct(liveVol * 100)} sub="realized vol" />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
